import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { listPortalInvoices } from "@/lib/portal.functions";
import { runServerFn } from "@/lib/server-fn";
import { PortalPageHeader } from "@/components/portal-shell";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusPill, statusTone } from "@/components/ui/status-pill";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

export const Route = createFileRoute("/_authenticated/portal/invoices")({ component: PortalInvoices });

const fmt = (cents: number, ccy: string) => new Intl.NumberFormat(undefined, { style: "currency", currency: ccy }).format(cents / 100);

function PortalInvoices() {
  const fetchInvoices = useServerFn(listPortalInvoices);
  const { data, isLoading } = useQuery({
    queryKey: ["portal-invoices"],
    queryFn: () => runServerFn(() => fetchInvoices(), "Loading invoices"),
  });
  return (
    <>
      <PortalPageHeader title="Invoices" description="Issued bills from your warehouse provider." />
      <div className="page-container">
      <div className="border rounded-lg bg-card overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Invoice #</TableHead><TableHead>Period</TableHead><TableHead className="text-right">Total</TableHead><TableHead>Status</TableHead><TableHead>Issued</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {isLoading ? (<TableRow><TableCell colSpan={6} className="text-center py-8 text-muted-foreground">Loading…</TableCell></TableRow>)
            : data && data.length > 0 ? data.map((i) => (
              <TableRow key={i.id}>
                <TableCell className="font-medium">{i.invoice_number}</TableCell>
                <TableCell className="text-muted-foreground">{i.period_start ?? "—"} → {i.period_end ?? "—"}</TableCell>
                <TableCell className="text-right tabular-nums">{fmt(i.total_cents, i.currency)}</TableCell>
                <TableCell><StatusPill tone={statusTone(i.status)}>{i.status}</StatusPill></TableCell>
                <TableCell className="text-muted-foreground">{i.issued_at ? new Date(i.issued_at).toLocaleDateString() : "—"}</TableCell>
                <TableCell className="text-right">
                  <Button size="sm" variant="ghost" asChild>
                    <Link to="/app/billing/$invoiceId/print" params={{ invoiceId: i.id }} target="_blank">
                      <ExternalLink className="h-4 w-4 mr-1" />View
                    </Link>
                  </Button>
                </TableCell>
              </TableRow>
            )) : (<TableRow><TableCell colSpan={6} className="text-center py-8 text-muted-foreground">No invoices yet.</TableCell></TableRow>)}
          </TableBody>
        </Table>
      </div>
      </div>
    </>
  );
}
